import { Theme } from '@core-ui/react-stitch';


const buttonBackgroundColorForBananaRepublic = (t: Theme, isApplied: boolean) => isApplied ? t.color.b1 : t.color.wh;

const buttonBackgroundColorForBananaRepublicRedesign = (t: Theme, isApplied: boolean) => isApplied ? t.color.b2 : t.color.inverse?.b1;

export const getButtonBackgroundColorForBananaRepublic = (t: Theme, isBRRedesignEnabled: boolean, isApplied: boolean) => isBRRedesignEnabled ? buttonBackgroundColorForBananaRepublicRedesign(t, isApplied) : buttonBackgroundColorForBananaRepublic(t, isApplied);

const getAppliedButtonTextColorForBR = (t: Theme, isBRRedesignEnabled: boolean) => isBRRedesignEnabled ? t.color.inverse.b1 : t.color.wh;

export const getButtonTextColorForBananaRepublic = (t: Theme, isBRRedesignEnabled: boolean, isApplied: boolean) => {
  if (isApplied) {
    return getAppliedButtonTextColorForBR(t, isBRRedesignEnabled);
  }
  return isBRRedesignEnabled ? t.color.b2 : t.color.g2;
};
